import { stats } from "@/data/athlete";
import { SectionHeader } from "./_shared";

export const Stats = () => {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="border-t border-zinc-900 py-16 md:py-24 bg-[#0c0c0c]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeader
          eyebrow="02 — Season Averages"
          title="By The Numbers"
          kicker={stats.season}
          testId="stats-header"
        />

        <div
          data-testid="stats-grid"
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4"
        >
          {stats.items.map((s) => (
            <div
              key={s.label}
              data-testid={`stat-${s.label
                .toLowerCase()
                .replace("%", "pct")
                .replace("/", "-")}`}
              className="bg-[#141414] border border-zinc-800 px-4 py-5 md:px-5 md:py-6 flex flex-col gap-2 hover:border-[#FF3B30] transition-colors min-w-0"
            >
              <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-bold text-[#FF3B30]">
                {s.label}
              </span>
              <span className="font-display text-5xl md:text-6xl text-white leading-none tabular-nums">
                {s.value}
              </span>
              <span className="text-[10px] md:text-xs uppercase tracking-wider text-zinc-500 font-semibold">
                {s.caption}
              </span>
            </div>
          ))}
        </div>

        {/* Defensive Impact line — reserved space for descriptive text */}
        <p
          data-testid="stats-defensive-impact"
          className="mt-6 md:mt-8 text-sm md:text-base text-zinc-400 italic"
        >
          {stats.defensiveImpact}
        </p>
      </div>
    </section>
  );
};
